// Angular
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// Partials
import { PartialsModule } from '../partials/partials.module';
// Pages
import { CoreModule } from '../../core/core.module';
import { MyPageComponent } from './my-page/my-page.component';
import { ShoplineItauComponent } from './shopline-itau/shopline-itau.component';


@NgModule({
	declarations: [MyPageComponent],
	exports: [],
	imports: [
		CommonModule,
		CoreModule,
		PartialsModule,

	],
	providers: []
})
export class PagesModule {
}
